import { render, staticRenderFns } from "./PrivacyArgePopup.vue?vue&type=template&id=d38b45d8&scoped=true&"
import script from "./PrivacyArgePopup.vue?vue&type=script&lang=js&"
export * from "./PrivacyArgePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b45d8",
  null
  
)

export default component.exports